import { useEffect, useRef } from "react";
import { buildCertificateCanvas, downloadCertificate } from "@/lib/certificate";
import { Download, X } from "lucide-react";
import { SFX } from "@/lib/audio";

export default function CertificateModal({ name, levelName, stars, onClose }) {
  const previewRef = useRef(null);

  useEffect(() => {
    const canvas = buildCertificateCanvas({ name, levelName, stars });
    if (previewRef.current) {
      previewRef.current.innerHTML = "";
      canvas.style.maxWidth = "100%";
      canvas.style.height = "auto";
      canvas.style.borderRadius = "16px";
      canvas.style.border = "4px solid #281E12";
      previewRef.current.appendChild(canvas);
    }
  }, [name, levelName, stars]);

  const onDownload = () => {
    SFX.star();
    downloadCertificate({ name, levelName, stars });
  };

  return (
    <div
      className="fixed inset-0 z-50 grid place-items-center bg-tiger-deep/80 px-4 py-8 overflow-y-auto"
      onClick={onClose}
      data-testid="certificate-modal"
    >
      <div
        className="relative w-full max-w-3xl rounded-3xl border-[4px] border-tiger-deep bg-tiger-cream p-5 shadow-stickerXl animate-pop-in"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute -right-3 -top-3 grid h-10 w-10 place-items-center rounded-full border-[3px] border-tiger-deep bg-white shadow-sticker hover:-translate-y-0.5 transition-transform"
          data-testid="close-certificate"
          aria-label="Close"
        >
          <X className="h-5 w-5" />
        </button>

        <h3 className="font-heading text-2xl font-bold text-tiger-deep">
          📸 Your Tiger Hero Certificate!
        </h3>

        <div ref={previewRef} className="mt-4 flex justify-center" />

        <div className="mt-5 flex flex-wrap justify-center gap-3">
          <button
            onClick={onDownload}
            className="inline-flex items-center gap-2 rounded-full border-[3px] border-tiger-deep bg-tiger-orange px-6 py-3 font-heading text-lg font-bold text-white shadow-sticker hover:-translate-y-0.5 hover:shadow-stickerLg transition-transform"
            data-testid="download-certificate"
          >
            <Download className="h-5 w-5" /> Download Picture
          </button>
          <button
            onClick={onClose}
            className="rounded-full border-[3px] border-tiger-deep bg-white px-6 py-3 font-heading text-lg font-bold text-tiger-deep shadow-sticker hover:-translate-y-0.5 transition-transform"
            data-testid="dismiss-certificate"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
